define.alias("shared/components/shared/post/secondary/caption-writer", "settings/components/shared/post/secondary/caption-writer");